import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminShared.css";
import { API_BASE_URL } from "../config";

const STATUS_OPTIONS = ["New", "Contacted", "In Progress", "Closed"];

export default function AdminMessages() {
  const navigate = useNavigate();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const adminInfo = localStorage.getItem("adminInfo");
    if (!adminInfo) navigate("/admin");
    fetchMessages();
  }, [navigate]);

  const fetchMessages = async () => {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("adminInfo"))?.token;
      const res = await fetch(`${API_BASE_URL}/home/admin/getTouch`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const result = await res.json();
      setMessages(result.data || result);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this message?")) return;
    try {
      const token = JSON.parse(localStorage.getItem("adminInfo"))?.token;
      await fetch(`${API_BASE_URL}/home/admin/getTouch/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchMessages();
    } catch (err) {
      console.error(err);
    }
  };

  const handleStatusChange = async (id, status) => {
    try {
      const token = JSON.parse(localStorage.getItem("adminInfo"))?.token;
      await fetch(`${API_BASE_URL}/home/admin/getTouch/${id}/status`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ status }),
      });
      setMessages((prev) => prev.map((m) => (m._id === id ? { ...m, status } : m)));
    } catch (err) {
      console.error(err);
    }
  };

  if (loading) return (
    <div className="admin-list-container">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '80vh', gap: '20px' }}>
            <div className="loading-spinner"></div>
            <p style={{ fontWeight: 700, color: '#475569' }}>⏳ Syncing Communications Ledger...</p>
        </div>
    </div>
  );

  return (
    <div className="admin-list-container">
      <header className="admin-list-header">
        <div className="header-left-group">
          <img src="/logo.png" alt="FlyTutor" className="admin-header-logo" />
          <h1 className="admin-header-title">Communications Hub</h1>
        </div>
        <button className="module-badge" style={{ cursor: 'pointer', border: 'none' }} onClick={fetchMessages}>
          Sync Data 🔄
        </button>
      </header>

      <div className="admin-list-content">
        <div className="admin-info-bar">
          <div className="admin-user-tag">
            <div className="dot" style={{ background: '#f59e0b' }}></div>
            Operator: Analytics
          </div>
          <div className="admin-status-badge" style={{ background: '#fef3c7', color: '#92400e', padding: '6px 12px', borderRadius: '10px', fontSize: '0.8rem', fontWeight: '800' }}>
            {messages.length} ACTIVE MESSAGES
          </div>
        </div>

        <div className="admin-table-wrapper">
          <table className="elite-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Client Details</th>
                <th>Message Content</th>
                <th>Lifecycle</th>
                <th>Temporal Data</th>
                <th>Operations</th>
              </tr>
            </thead>
            <tbody>
              {messages.map((msg, i) => (
                <tr key={msg._id}>
                  <td>{i + 1}</td>
                  <td>
                    <div style={{ fontWeight: 700 }}>{msg.name}</div>
                    <div style={{ fontSize: '0.8rem', color: '#64748b' }}>{msg.email}</div>
                    <div style={{ fontSize: '0.8rem', color: '#64748b' }}>{msg.number}</div>
                  </td>
                  <td style={{ maxWidth: '300px' }}>
                    <div style={{ fontSize: '0.9rem', color: '#475569', lineHeight: '1.4' }}>{msg.message}</div>
                  </td>
                  <td>
                    <select
                      className={`status-tag status-${msg.status?.toLowerCase().replace(/\s+/g, '-')}`}
                      value={msg.status}
                      onChange={(e) => handleStatusChange(msg._id, e.target.value)}
                      style={{ border: 'none', cursor: 'pointer', outline: 'none' }}
                    >
                      {STATUS_OPTIONS.map((s) => (
                        <option key={s} value={s}>{s.toUpperCase()}</option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <div style={{ fontWeight: 600 }}>{new Date(msg.createdAt).toLocaleDateString("en-IN")}</div>
                    <div style={{ fontSize: '0.8rem', color: '#94a3b8' }}>{new Date(msg.createdAt).toLocaleTimeString("en-IN")}</div>
                  </td>
                  <td>
                    <button
                      className="action-btn-elite btn-delete"
                      onClick={() => handleDelete(msg._id)}
                    >
                      <span>🗑️</span> Purge
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
